import { CanAccess, useTranslate } from "ra-core";
import { Navigate } from "react-router";

import { WhatsAppConfigCard } from "./WhatsAppConfigCard";
import { WhatsAppCounterCard } from "./WhatsAppCounterCard";
import { WhatsAppHealthCard } from "./WhatsAppHealthCard";
import { WhatsAppTemplatesCard } from "./WhatsAppTemplatesCard";

const SettingsContent = () => {
  const translate = useTranslate();
  return (
    <div className="mx-auto mt-2 max-w-3xl space-y-4 pb-8">
      <h1 className="px-1 text-2xl font-bold">
        {translate("crm.whatsapp.settings.title")}
      </h1>
      <p className="px-1 text-[15px] text-muted-foreground">
        {translate("crm.whatsapp.settings.intro")}
      </p>
      <WhatsAppCounterCard />
      <WhatsAppHealthCard />
      <WhatsAppConfigCard />
      <WhatsAppTemplatesCard />
    </div>
  );
};

/**
 * Almikia Epic EW2 (TASK-080): the Direccion WhatsApp settings screen: the monthly counter, the
 * `whatsapp_config` editor (windows, quota, alert thresholds, go-live flags, welcome template,
 * button-lead greeting, send rate limit) and the template catalogue. Direccion only: every other
 * role is sent home, and the RLS of TASK-076 rejects their writes anyway.
 */
export const WhatsAppSettings = () => (
  <CanAccess
    resource="whatsapp_settings"
    action="list"
    accessDenied={<Navigate to="/" replace />}
  >
    <SettingsContent />
  </CanAccess>
);

WhatsAppSettings.path = "/whatsapp_settings";
